import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  PASSWORD_CHANGE_REQUEST,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  DELETE_ACCOUNT_REQUEST,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
  CONFIRM_PASSWORD_REQUEST,
  CONFIRM_PASSWORD_SUCCESS,
  CONFIRM_PASSWORD_FAILURE
} from "../actions/types";
import {
  login as loginApi,
  changePassword as changePasswordApi,
  verifyOtp as verifyOtpApi,
  deleteAccount as deleteAccountApi,
  confirmAdminPassword as confirmAdminPasswordApi,
} from "../../services/authService";

// Action Creators
export const loginRequest = () => ({ type: LOGIN_REQUEST });
export const loginSuccess = (userData) => ({
  type: LOGIN_SUCCESS,
  payload: userData,
});
export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
});

export const logout = () => {
  localStorage.removeItem("access_token");
  return { type: LOGOUT };
};

// Action Creators for password change
export const passwordChangeRequest = () => ({ type: PASSWORD_CHANGE_REQUEST });
export const passwordChangeSuccess = (message) => ({
  type: PASSWORD_CHANGE_SUCCESS,
  payload: message,
});
export const passwordChangeFailure = (error) => ({
  type: PASSWORD_CHANGE_FAILURE,
  payload: error,
});

export const verifyOtpRequest = () => ({ type: VERIFY_OTP_REQUEST });

export const verifyOtpSuccess = (data) => ({
  type: VERIFY_OTP_SUCCESS,
  payload: data,
});

export const verifyOtpFailure = (error) => ({
  type: VERIFY_OTP_FAILURE,
  payload: error,
});

// Delete Account action creators
export const deleteAccountRequest = () => ({ type: DELETE_ACCOUNT_REQUEST });
export const deleteAccountSuccess = (message) => ({
  type: DELETE_ACCOUNT_SUCCESS,
  payload: message,
});
export const deleteAccountFailure = (error) => ({
  type: DELETE_ACCOUNT_FAILURE,
  payload: error,
});

//Confirm password
export const confirmPasswordRequest = () => ({ type: CONFIRM_PASSWORD_REQUEST });

export const confirmPasswordSuccess = (message) => ({
  type: CONFIRM_PASSWORD_SUCCESS,
  payload: message,
});

export const confirmPasswordFailure = (error) => ({
  type: CONFIRM_PASSWORD_FAILURE,
  payload: error,
});


//login thunk
export const login = (email, password) => async (dispatch) => {
  dispatch(loginRequest());
  try {
    const response = await loginApi(email, password);
    if (response.access_token) {
      dispatch(loginSuccess(response));
      return response;
    } else {
      dispatch(loginFailure(response.error || "Login failed"));
      return { success: false, error: response.error || "Login failed" };
    }
  } catch (error) {
    dispatch(loginFailure(error.message || "Login failed"));
    return { success: false, error: error.message || "Login failed" };
  }
};

// Thunk for handling password change
export const changePassword = (email, currentPassword, newPassword) => async (dispatch) => {
  dispatch(passwordChangeRequest());

  try {
    const response = await changePasswordApi(email, currentPassword, newPassword);

    if (response?.success) {
      dispatch(passwordChangeSuccess(response.message || "Password changed successfully!"));
      return { success: true, message: response.message };
    } else {
      dispatch(passwordChangeFailure(response.error || "Password change failed"));
      return { success: false, error: response.error || "Password change failed" };
    }
  } catch (error) {
    dispatch(passwordChangeFailure(error.message || "Password change failed"));
    return { success: false, error: error.message || "Password change failed" };
  }
};

//confirm passowrd
export const confirmAdminPassword = (password) => async (dispatch) => {
  dispatch(confirmPasswordRequest());

  try {
    const response = await confirmAdminPasswordApi(password);

    if (response?.success) {
      dispatch(confirmPasswordSuccess(response.message));
      return { success: true, message: response.message };
    } else {
      dispatch(confirmPasswordFailure(response.error || "Password confirmation failed"));
      return { success: false, error: response.error || "Password confirmation failed" };
    }
  } catch (error) {
    dispatch(confirmPasswordFailure(error.message || "Password confirmation failed"));
    return { success: false, error: error.message || "Password confirmation failed" };
  }
};


export const verifyOtp = ({ user_id, otp }) => async (dispatch) => {
  dispatch(verifyOtpRequest());

  try {
    const response = await verifyOtpApi({ user_id, otp });

    if (response?.success) {
      dispatch(verifyOtpSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      dispatch(verifyOtpFailure(response.error || "OTP verification failed"));
      return { success: false, error: response.error || "OTP verification failed" };
    }
  } catch (error) {
    dispatch(verifyOtpFailure(error.message || "OTP verification failed"));
    return { success: false, error: error.message || "OTP verification failed" };
  }
};

// Delete Account thunk
export const deleteAccount = (user_id) => async (dispatch) => {
  dispatch(deleteAccountRequest());

  try {
    const response = await deleteAccountApi(user_id);

    if (response?.success) {
      dispatch(deleteAccountSuccess(response.message || "Account deleted successfully"));
      return { success: true, message: response.message };
    } else {
      dispatch(deleteAccountFailure(response.error || "Account deletion failed"));
      return { success: false, error: response.error || "Account deletion failed" };
    }
  } catch (error) {
    dispatch(deleteAccountFailure(error.message || "Account deletion failed"));
    return { success: false, error: error.message || "Account deletion failed" };
  }
};